import { FC } from 'react';

interface AllieDividerProps {
  className?: string;
}

export const AllieDivider: FC<AllieDividerProps> = ({ className }) => (
  <hr
    className={className}
    style={{
      borderTop: 1,
      borderStyle: 'solid',
      borderTopColor: 'lightgray',
      width: '100%',
    }}
  />
);
